import React, { useState, useContext } from 'react'
import { ContentInner } from '../../../../../layout/Content'
import ProductsSoldInnerStyle from './css/ProductsSoldInnerStyle'
import { productsSoldContext } from './ProductsSoldController'
import PrinterSettingsStyle from '../../../../../../css/PrinterSettingsStyle'
import { formatNumber, simpleDateString } from '../../../../../utilities/utilities'

function ProductsSoldInner() {
  const productsSoldController = useContext(productsSoldContext)
  const { app } = productsSoldController
  const [productsSold, setProductsSold] = productsSoldController.productsSold
  const date = productsSoldController.date[0]
  const [psSorted, setPSSorted] = useState(true)

  const onClickSort = (e) => {
    switch(e.target.id) {
      case 'product-name':
        productsSold.sort((a, b) => {
          let x, y
          if (!psSorted) {
            x = a.item_name.toLowerCase()
            y = b.item_name.toLowerCase()
          } else {
            x = b.item_name.toLowerCase()
            y = a.item_name.toLowerCase()
          }

          if (x < y) return -1
          if (x > y) return 1
          return 0
        })
      break
      case 'quantity-sold':
        productsSold.sort((a, b) => {
          let sorted
          if (!psSorted)
            sorted = a.total_quantity_sold - b.total_quantity_sold
          else
            sorted = b.total_quantity_sold - a.total_quantity_sold
          return sorted
        })
      break
      case 'price-sold-total':
        productsSold.sort((a, b) => {
          let sorted
          if (!psSorted)
            sorted = a.total_amount_sold - b.total_amount_sold
          else
            sorted = b.total_amount_sold - a.total_amount_sold
          return sorted
        })
      break
      default:
    }

    setPSSorted(!psSorted)
    setProductsSold(productsSold)
  }

  return (
    <ContentInner>
      <div className='report-wrapper'>
        <div id='products-sold-container' className='printable'>
          <h3>Products Sold Report</h3>
          <br />
          <div className='dates-header-container'>
            <div className='date-left'>
              <div style={{display: 'flex'}}> <div style={{fontWeight: 'bold', width: '50px'}}>From:</div>{simpleDateString(new Date(date.from))}</div>
              <div style={{display: 'flex'}}><div style={{fontWeight: 'bold', width: '50px'}}>To:</div>{simpleDateString(new Date(date.to))}</div>
            </div>
            <div className='date-right'>As of {new Date(app.getClientDateTime()).toLocaleString("en-us")} { app.getClientTimezone() }</div>
          </div>
          <br />
          <table className='products-sold-table'>
            <thead>
              <tr>
                <th style={{textAlign: 'left'}}>
                  <div
                    id='product-name'
                    className='sortable-header'
                    onClick={onClickSort}
                    style={{paddingLeft: '0'}}
                    title='sort'>
                    Product Name
                  </div>
                </th>
                <th style={{textAlign: 'left'}}>Unit</th>
                <th>
                  <div
                    id='quantity-sold'
                    className='sortable-header'
                    onClick={onClickSort}
                    title='sort'>
                    Quantity Sold
                  </div>
                </th>
                <th style={{textAlign: 'right'}}>
                  <div
                    id='price-sold-total'
                    className='sortable-header'
                    onClick={onClickSort}
                    title='sort'>
                    Price Sold Total
                  </div>
                </th>
              </tr>
            </thead>
            {
              (productsSold)
              ? productsSold.map((ps, index) => (
                  <tbody key={index}>
                    <tr>
                      <td>{ps.item_name}</td>
                      <td>{ps.item_unit}</td>
                      <td style={{textAlign: 'center'}}>{formatNumber(ps.total_quantity_sold)}</td>
                      <td style={{textAlign: 'right'}}>P{formatNumber(ps.total_amount_sold)}</td>
                    </tr>
                  </tbody>
                ))
              : null
            }
            {
              (productsSold)
              ? <tbody>
                  <tr>
                    <td></td>
                    <td></td>
                    <th>Total</th>
                    <th style={{textAlign: 'right'}}>P{formatNumber(productsSold.reduce((acc, cur) => (acc + cur.total_amount_sold), 0))}</th>
                  </tr>
                </tbody>
              : null
            }
            <tbody>
              <tr>
                <td colSpan='3'><b>Number of Items:</b> {(productsSold) ? productsSold.length : 0}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ProductsSoldInnerStyle />
      <PrinterSettingsStyle paperWidth='8.5inch'/>
    </ContentInner>
  )
}

export default React.memo(ProductsSoldInner)